export default __webpack_public_path__ + "static/Selo_Cubo_Startup_2024_positivo_RGB-0ac7b0185c7fbdc6aac1734c223fd696.svg";